import { mapMultiItemContextInput } from 'stores/adapters/bex-api/search/multi-item/multi-item-context-adapter';
export const getShoppingContextInput = multiItemContext => ({
  multiItem: mapMultiItemContextInput(multiItemContext)
});